// extracted by mini-css-extract-plugin
export default {"line":"styles_line__WDEwJ","lineName":"styles_lineName__VO660","lineValue":"styles_lineValue__sEii5"};